module.exports = __webpack_public_path__ + "static/media/item_39_4.3ce77da2.png";